enum PromptOptions {
  SelectCamera = 'SelectCamera',
  DeviceHandoff = 'DeviceHandoff',
  UploadImage = 'UploadImage',
}

export default PromptOptions;
